import { useMutation } from 'react-query';
import { type HTTPError } from 'ky';

import { useNotifications } from 'src/notifications';
import type { IStandardErrorResponse } from 'src/api/common';
import { type TempLoginData } from 'src/pages/landlord/login/LandlordLogin';
import Auth, { type LoginResponse } from 'src/services/api/auth/Auth';

export const useSwitchTeam = (tempLoginData?: TempLoginData) => {
    const { addNotification } = useNotifications();

    return useMutation<LoginResponse, IStandardErrorResponse, number>(
        async (payload) => Auth.loginSwitchingTeam(payload, tempLoginData),
        {
            onError: async (error) => {
                let errorMsg = error.msg || 'Failed to switch teams';
                if ((error as any).response?.status === 403) {
                    const typedErr = (error as unknown) as HTTPError;
                    const j = await typedErr.response.json<IStandardErrorResponse>();
                    if (j.error_code === 'PERM_DENIED') {
                        errorMsg = `Failed to switch teams: ${j.msg}`;
                    }
                } else {
                    console.error('Failed to switch teams uncaught error', error);
                }

                addNotification(errorMsg, 'error');
            }
        }
    );
};
